type NamedItem = { id: string; name?: string; generatedName?: string };

export const getProductName = (item: NamedItem) => item.generatedName || item.name || item.id;

export const filterProductsByName = <T extends NamedItem>(items: T[], query: string): T[] => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return items;
  return items.filter((item) => getProductName(item).toLowerCase().includes(normalizedQuery));
};
